(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carcover-tailored-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setupTailoredGallery(track) {
      if (track.dataset.tailoredGalleryReady === 'true') {
        return;
      }

      track.dataset.tailoredGalleryReady = 'true';

      var active = false;
      var moved = false;
      var startX = 0;
      var startScrollLeft = 0;
      var autoplay = track.dataset.tailoredGalleryAutoplay === 'true';
      var speed = Number(track.dataset.tailoredGallerySpeed || 24);
      var direction = Number(track.dataset.tailoredGalleryDirection || 1);
      var pauseOnHover = track.dataset.tailoredGalleryPauseHover === 'true';
      var hovering = false;
      var pageHidden = document.hidden;
      var lastTime = 0;
      var animationFrame = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var reverseStartSet = false;

      if (direction !== -1) {
        direction = 1;
      }

      function loopPoint() {
        var marker = track.querySelector('[data-tailored-gallery-duplicate-start]');

        if (!marker) {
          return track.scrollWidth - track.clientWidth;
        }

        return marker.offsetLeft - track.offsetLeft;
      }

      function canAutoplay() {
        return autoplay && !reduceMotion.matches && track.scrollWidth > track.clientWidth + 8 && loopPoint() > 8;
      }

      function normalizeScroll() {
        var point = loopPoint();

        if (point <= 8) {
          return;
        }

        if (direction === -1 && track.scrollLeft <= 1) {
          track.scrollLeft = track.scrollLeft + point;
          return;
        }

        if (track.scrollLeft >= point) {
          track.scrollLeft = track.scrollLeft - point;
        }
      }

      function animate(time) {
        if (!track.isConnected) {
          if (animationFrame) {
            window.cancelAnimationFrame(animationFrame);
          }

          return;
        }

        if (!lastTime) {
          lastTime = time;
        }

        var elapsed = (time - lastTime) / 1000;
        lastTime = time;

        if (canAutoplay() && !active && !pageHidden && (!hovering || !pauseOnHover)) {
          if (direction === -1 && !reverseStartSet) {
            track.scrollLeft = loopPoint();
            reverseStartSet = true;
          }

          track.scrollLeft += direction * speed * elapsed;
          normalizeScroll();
        }

        animationFrame = window.requestAnimationFrame(animate);
      }

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }

        active = true;
        moved = false;
        lastTime = 0;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!active) {
          return;
        }

        var distance = event.clientX - startX;

        if (Math.abs(distance) > 4) {
          moved = true;
        }

        track.scrollLeft = startScrollLeft - distance;
      });

      function endDrag(event) {
        if (!active) {
          return;
        }

        active = false;
        track.classList.remove('is-dragging');
        normalizeScroll();
        if (direction === -1 && track.scrollLeft > 1) {
          reverseStartSet = true;
        }
        lastTime = 0;

        if (track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener(
        'click',
        function (event) {
          if (!moved) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          moved = false;
        },
        true
      );

      track.addEventListener('mouseenter', function () {
        hovering = true;
        lastTime = 0;
      });

      track.addEventListener('mouseleave', function () {
        hovering = false;
        lastTime = 0;
      });

      document.addEventListener('visibilitychange', function () {
        pageHidden = document.hidden;
        lastTime = 0;
      });

      window.addEventListener('resize', function () {
        reverseStartSet = false;
        normalizeScroll();
        lastTime = 0;
      });

      if (autoplay) {
        animationFrame = window.requestAnimationFrame(animate);
      }
    }

    function initTailoredGalleries(root) {
      root.querySelectorAll('[data-tailored-gallery-track]').forEach(setupTailoredGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initTailoredGalleries(document);
      });
    } else {
      initTailoredGalleries(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initTailoredGalleries(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carcovermegaheader"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var desktopQuery = window.matchMedia('(min-width: 990px)');

    function closeItem(item) {
      item.removeAttribute('open');
    }

    function setupHeader(header) {
      if (header.dataset.ccMegaReady === 'true') {
        return;
      }

      header.dataset.ccMegaReady = 'true';

      var items = Array.from(header.querySelectorAll('[data-cc-mega-item]'));

      function closeOthers(activeItem) {
        items.forEach(function (item) {
          if (item !== activeItem) {
            closeItem(item);
          }
        });
      }

      items.forEach(function (item) {
        var summary = item.querySelector('summary');
        var closeTimer = null;

        function clearCloseTimer() {
          if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
          }
        }

        item.addEventListener('mouseenter', clearCloseTimer);

        summary.addEventListener('mouseenter', function () {
          if (!desktopQuery.matches) {
            return;
          }

          clearCloseTimer();
          closeOthers(item);
          item.setAttribute('open', '');
        });

        item.addEventListener('mouseleave', function () {
          if (desktopQuery.matches) {
            clearCloseTimer();
            closeTimer = window.setTimeout(function () {
              closeItem(item);
              closeTimer = null;
            }, 180);
          }
        });

        summary.addEventListener('click', function (event) {
          if (!desktopQuery.matches) {
            closeOthers(item);
            return;
          }

          event.preventDefault();
          clearCloseTimer();

          if (item.hasAttribute('open')) {
            closeItem(item);
          } else {
            closeOthers(item);
            item.setAttribute('open', '');
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (header.contains(event.target)) {
          return;
        }

        items.forEach(closeItem);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
          return;
        }

        items.forEach(closeItem);
      });
    }

    function init(root) {
      root.querySelectorAll('[data-cc-mega-header]').forEach(setupHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-stories-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function cardsPerView() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        return 1;
      }

      if (window.matchMedia('(max-width: 989px)').matches) {
        return 2;
      }

      return 3;
    }

    function setupStories(section) {
      if (section.dataset.customerStoriesReady === 'true') {
        return;
      }

      section.dataset.customerStoriesReady = 'true';

      var track = section.querySelector('[data-stories-track]');
      var prev = section.querySelector('[data-stories-prev]');
      var next = section.querySelector('[data-stories-next]');
      var dots = section.querySelector('[data-stories-dots]');

      if (!track || !prev || !next || !dots) {
        return;
      }

      var slides = Array.from(section.querySelectorAll('[data-stories-slide]'));
      var dotLabel = section.dataset.dotLabel || 'Go to testimonial page [index]';
      var currentPage = 0;
      var dotCount = 0;
      var scrollFrame = null;

      function pageCount() {
        return Math.max(1, Math.ceil(slides.length / cardsPerView()));
      }

      function clampPage(page) {
        return Math.max(0, Math.min(page, pageCount() - 1));
      }

      function targetLeftForPage(page) {
        var index = Math.min(page * cardsPerView(), slides.length - 1);
        var slide = slides[index];
        return slide ? slide.offsetLeft - track.offsetLeft : 0;
      }

      function buildDots() {
        var total = pageCount();

        if (dotCount === total) {
          return;
        }

        dotCount = total;
        dots.innerHTML = '';

        for (var index = 0; index < total; index += 1) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'cc-stories__dot';
          button.setAttribute('aria-label', dotLabel.replace('[index]', String(index + 1)));
          button.dataset.storiesPage = String(index);
          button.addEventListener('click', function (event) {
            goToPage(Number(event.currentTarget.dataset.storiesPage), true);
          });
          dots.appendChild(button);
        }
      }

      function currentPageFromScroll() {
        var view = cardsPerView();
        var closestIndex = 0;
        var closestDistance = Number.POSITIVE_INFINITY;

        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return clampPage(Math.round(closestIndex / view));
      }

      function updateState() {
        buildDots();
        currentPage = currentPageFromScroll();

        Array.from(dots.children).forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === currentPage);
          dot.setAttribute('aria-current', index === currentPage ? 'true' : 'false');
        });

        var disabled = pageCount() <= 1;
        prev.disabled = disabled || currentPage === 0;
        next.disabled = disabled || currentPage === pageCount() - 1;
      }

      function goToPage(page, smooth) {
        currentPage = clampPage(page);
        track.scrollTo({
          left: targetLeftForPage(currentPage),
          behavior: smooth ? 'smooth' : 'auto'
        });
        updateState();
      }

      prev.addEventListener('click', function () {
        goToPage(currentPage - 1, true);
      });

      next.addEventListener('click', function () {
        goToPage(currentPage + 1, true);
      });

      track.addEventListener('scroll', function () {
        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = window.requestAnimationFrame(updateState);
      });

      window.addEventListener('resize', function () {
        dotCount = 0;
        goToPage(currentPage, false);
      });

      updateState();
    }

    function init(root) {
      root.querySelectorAll('[data-customer-stories]').forEach(setupStories);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
